<template>
  <div>
    <YsApply />
  </div>
</template>

<script>
// 获取接口地址
import YsApply from '@/components/yssq/ysApply'

export default {
  name: 'Yssq',
  components: {
    // sideMenu,
    // Header,
    YsApply

  },
  data() {
    return {

    }
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
